import anchorme from 'anchorme';
import striptags from 'striptags';
import { escapeHtml } from 'shared-helpers/common';

interface Params {
  text: string;
  sanitize?: boolean;
}

const anchorText = ({ text, sanitize = false }: Params) => {
  let processedText = '';
  if (sanitize) {
    // Only sanitize if this is raw user input.
    // The result goes into dangerouslySetInnerHTML, so nothing here may
    // survive as a tag. Line breaks become newlines first, then every
    // remaining tag is stripped and the leftovers are escaped.
    // Do not whitelist <br> in striptags instead: it keeps the tag's
    // attributes, so <br tabindex=0 onfocus=...> would reach the DOM intact.
    processedText = escapeHtml(striptags(text.replace(/<br\s*\/?>/gi, '\n')));
  } else {
    // For already-sanitized content, safely unescape URL-friendly characters that
    // we manually escaped (for example, inside chatMessage.js beforeValidate hook)
    processedText = text
      .replace(/&#x2F;/g, '/') // Unescape forward slashes
      .replace(/&#x5C;/g, '\\'); // Unescape backslashes if needed
    // Keep dangerous characters escaped: <, >, ", ', &
  }

  return anchorme({
    input: processedText,
    options: { attributes: { target: '_blank', rel: 'noopener noreferrer' } }
  });
};

export default anchorText;
